import useAuthStore from '../store/AuthStore'
import { getCookieValue, parseJsonList } from '../utils/index'

export const AFFILIATION_KEY = 'affiliation'
export const USER_ROLE_KEY = 'userRole'

interface EcommerceEventProps {
  event: string,

  // login
  userId?: string,
  userType?: string,
  username?: string,

  // select_item, complete_action, view_item
  item_id?: string, //ordine commerciale
  item_name?: string, // marca+modello+allestimento
  affiliation?: string //partner di riferimento dell'utente (custom:reference_partner)
  item_category?: string, // marca
  item_category2?: string, //modello+allestimento
  item_category3?: string, //codiceCostruttore
  item_category4?: string, //disponibilità
  item_category5?: string, //disponibilità
  item_category6?: string, //disponibilità
  item_category7?: string, //disponibilità
  note_gerarchiche?: string
  advance?: string, //anticipo
  price?: number, //canone mensile

  // CTA event
  category?: string,
  action?: string,
  label?: string,
  actionType?: string,
  evtCat?: string, // categoria
  evtAct?: string, // azione
  evtLab?: string, // label

  // wishlist
  wishlist_action?: string,
  item_variant?: string,
  colour?: string

  // dealer
  groupName?: string

  // Quicko
  provvigioni?: string
  canone?: string
  noleggiatore?: string

  veicolo?: any

  date?: string
  dealer?: string //dealer del veicolo

}

/**
 * Il partner di riferimento dell'utente loggato.
 */
export const getUserAffiliation = (): string | undefined => {
  const { user } = useAuthStore.getState();

  return parseJsonList(user?.attributes?.['custom:reference_partner'])[0]
    || getCookieValue(AFFILIATION_KEY)
    || localStorage.getItem(AFFILIATION_KEY)
    || undefined;
};

/**
 * Il ruolo dell'utente loggato.
 */
export const getUserRole = (): string | undefined => {
  const { user } = useAuthStore.getState();
  const roleFromLocalStorage = localStorage.getItem(USER_ROLE_KEY);

  return user?.attributes?.['custom:role']
    || getCookieValue(USER_ROLE_KEY)
    || (roleFromLocalStorage ? parseJsonValue(roleFromLocalStorage) : undefined)
    || undefined;
};

const parseJsonValue = (value: string) => {
  try {
    return JSON.parse(value);
  } catch (error) {
    return value;
  }
};

export const GTMsendEvent = (props: EcommerceEventProps) => {
  const { user } = useAuthStore.getState();
  if (dataLayerExists()) {

    const filteredItems: EcommerceEventProps = {
      event: props.event
    };

    const userIdFromCookies = getCookieValue('userID');
    const userIdfromLocalStorage = localStorage.getItem('userID')
    const username = localStorage.getItem('username')
    const userId = props.userId
      || user?.attributes?.sub
      || userIdFromCookies
      || userIdfromLocalStorage;

    const affiliation = props.affiliation || getUserAffiliation();
    const userType = props.userType || getUserRole();

    for (const [key, value] of Object.entries(props)) {
      if (key !== 'event' && key !== 'userId' && props[key] !== undefined && props[key] !== null && props[key] !== '') {
        filteredItems[key] = value
      }
    }

    (window as any).dataLayer.push({
      ...filteredItems,
      ...(affiliation ? { affiliation } : {}),
      ...(userType ? { userType } : {}),
      userID: userId,
      username: username
    });
  }
};

export const updateConsent = () => {
  if (typeof (window as any).gtag === 'function') {
    (window as any).gtag('consent', 'update', {
      'ad_storage': 'granted',
      'analytics_storage': 'granted',
      'functionality_storage': 'granted',
      'personalization_storage': 'granted'
    });
  } else {
    console.error('gtag is not defined');
    // handle the error with a fedeback message for the user
  }
}

export const sendLoginToGTM = (consent, userRole) => {
  consent && GTMsendEvent({
    event: 'login',
    userType: userRole
  })
}

export const PENDING_LOGIN_KEY = 'pendingLoginEvent'

export const queueLoginEvent = (userRole?: string) => {
  sessionStorage.setItem(PENDING_LOGIN_KEY, userRole || '');
};

export const flushPendingLoginEvent = () => {
  const pendingUserRole = sessionStorage.getItem(PENDING_LOGIN_KEY);

  if (pendingUserRole === null) {
    return;
  }

  sessionStorage.removeItem(PENDING_LOGIN_KEY);

  const rawConsent = localStorage.getItem('tracking_consent');
  const consent = rawConsent ? parseJsonValue(rawConsent) : false;

  sendLoginToGTM(consent, pendingUserRole || undefined);
};

const dataLayerExists = () => {
  return (window as any).dataLayer && Array.isArray((window as any).dataLayer)
}
